import { projectWorkActions } from '@shared/work-action';
import { supabase } from './supabase';
import { toDashboardUiError } from './dashboard-errors';
import type { WorkActionContext } from '@shared/types/work-action';

export const requestWork = async (context: WorkActionContext, request: string | null, requestId: string) => {
  const { data, error } = await supabase.functions.invoke('activity-feed', { body: {
    action: 'prepare_work', subjectId: context.subjectId, topicId: context.topicId,
    expectedVersion: context.topicVersion, request, requestId,
  } });
  if (error) throw new Error((await toDashboardUiError(error, 'La demande n’a pas pu être enregistrée. Vous pouvez reprendre sans perdre votre saisie.')).message);
  if (!data || typeof data.topicId !== 'string' || typeof data.threadId !== 'string' || typeof data.jobId !== 'string' || typeof data.topicVersion !== 'number') {
    throw new Error('La réponse de préparation est incomplète. Actualisez le compte avant de reprendre.');
  }
  return data as { topicId: string; threadId: string; jobId: string; topicVersion: number; status: string; reused?: boolean; reply?: string };
};
/** Re-queues the same failed evaluation (T4 RPC): its reason and split policy are
 * kept, so a split child cannot split again (audit TRAV-04). */
export const retryWorkEvaluation = async (topicId: string) => {
  const { data, error } = await supabase.functions.invoke('activity-feed', { body: { action: 'retry_evaluation', topicId } });
  if (error) throw new Error((await toDashboardUiError(error, 'La préparation n’a pas pu être relancée. Réessayez dans un instant.')).message);
  if (!data || typeof data.jobId !== 'string') throw new Error('La réponse de reprise est incomplète. Actualisez le compte avant de reprendre.');
  return data as { topicId: string; jobId: string; status: string; reused?: boolean };
};
import type { ActivitySubjectCard, ActivitySubjectDetail } from '@shared/types/activity-feed';

/** One compatibility boundary for old server responses. */
export const getSubjectWorkActions = (subject: ActivitySubjectCard | ActivitySubjectDetail) =>
  subject.workActions ?? projectWorkActions({ subject, threadState: subject.threadState,
    recommendations: 'recommendations' in subject ? subject.recommendations : subject.recommendedActions });
